import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import DeletePopUp from '../Shared/DeletePopUp';
import { toast } from 'react-toastify';
import { closeRoleModal } from '../../Store/Slices/brSlice';
import { useDeleteRoleMutation } from '../../Store/Services/RoleService';


const DeleteRole = () => {

    const dispatch = useDispatch();
    const roles = useSelector((state) => state.roles);

    const [deleteRole] = useDeleteRoleMutation();

    const onDeleteConfirm = async () => {
        const id = roles.selectedRole;
        try {
            const deletedRole = await deleteRole(id).unwrap();
            // toast.success("Role successfully deleted!");
        } catch (err) {
            console.error('Failed to delete the roles: ', err)
            toast.error("Erorr, something went wrong!");
        }
        dispatch(closeRoleModal());
    }

    return (
        <DeletePopUp
            data="Role"
            close={() => dispatch(closeRoleModal())}
            onDeleteConfirm={onDeleteConfirm}
        />
    )
}

export default DeleteRole